import React from 'react';
import { useSelector } from 'react-redux';
import Product from '../Product/Product';

const AvailableProducts = () => {

  const products = useSelector(state => state.products);

    return (
        <>
            {/* <!-- products container --> */}
          <div className="productContainer" id="lws-productContainer">
            {/* <!-- product item --> */}
            {!products.length && <p className='text-xl text-center font-bold'>There is no product here.</p> }
            {
              products.map(product => <Product key={product.id} product={product}></Product>)
            }    
          </div>
          {/* <!-- products container ends --> */}
        </>
    );
};

export default AvailableProducts;